<div class="text-center">
  <section>
    <img src="{{userimage}}" alt="Profile picture of {{userprofile.name}}" class="user-img bg-gray-100 rounded-circle shadow-sm-darker object-cover object-center">
    <h3 class="mt-3 font-weight-500">{{userprofile.name}}</h3>
    <div class="text-sm">
      <div *ngIf="userprofile.email && userprofile.showEmail"><a href="mailto:{{userprofile.email}}" class="text-link">{{userprofile.email}}</a></div>
      <div *ngIf="userprofile.phoneno && userprofile.showPhone"><a href="tel:{{userprofile.phoneno}}" class="text-link">{{userprofile.phoneno}}</a></div>
      <div>Timezone: {{userprofile.timeZoneName}} (UTC {{userprofile.timeZone}})</div>
      <div class="d-flex justify-content-center flex-wrap gap-.3 my-3">
        <a *ngIf="userprofile.website" href="{{userprofile.website}}" target="_blank" rel="noopener noreferrer">
          <button class="btn-white btn-icon-only rounded-circle border-0 activate-bounce--on-hover" title="Website"><i class="fa fa-globe bounce"></i></button>
        </a>
        <a *ngIf="userprofile.facebook" href="{{userprofile.facebook}}" target="_blank" rel="noopener noreferrer">
          <button class="btn-facebook btn-icon-only rounded-circle border-0 activate-bounce--on-hover" title="Facebook"><i class="fab fa-facebook bounce"></i></button>
        </a>
        <a *ngIf="userprofile.twitter" href="{{userprofile.twitter}}" target="_blank" rel="noopener noreferrer">
          <button class="btn-twitter btn-icon-only rounded-circle border-0 activate-bounce--on-hover" title="Twitter"><i class="fab fa-twitter bounce"></i></button>
        </a>
        <a *ngIf="userprofile.linkedin" href="{{userprofile.linkedin}}" target="_blank" rel="noopener noreferrer">
          <button class="btn-facebook btn-icon-only rounded-circle border-0 activate-bounce--on-hover" title="LinkedIn"><i class="fab fa-linkedin bounce"></i></button>
        </a>  
      </div>
    </div>  
  </section>
  <section>
    <h4>About Me</h4>
    <div [innerHTML]="userprofile.safeBio" class="innerHTML-wrap mx-auto"></div>  
  </section>
</div>
